<script setup>
import { defineModel } from 'vue'

const modelValue = defineModel()
const emits = defineEmits(['confirm'])

defineProps({
    isLoading: {
        type: Boolean,
        default: false,
    },
})

const onCancel = () => {
    modelValue.value = false
}

const onAccept = () => {
    emits('confirm')
}
</script>

<template>
    <v-dialog
        data-test="confirmation-dialog"
        v-model="modelValue"
        persistent
        width="auto"
    >
        <v-card class="!rounded-lg">
            <v-card-item
                density="compact"
                class="!py-2 !px-4 bg-gray-100 border-b"
            >
                <slot name="title" />
                <template v-slot:append>
                    <v-btn
                        size="x-small"
                        variant="text"
                        icon="fal fa-close"
                        color="primary"
                        class="rounded-md"
                        @click="onCancel"
                    >
                    </v-btn>
                </template>
            </v-card-item>

            <v-card-text data-test="confirmation-dialog-body" class="!px-4">
                <slot name="body" />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    data-test="confirmation-dialog-btn-close"
                    variant="outlined"
                    @click="onCancel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    :loading="isLoading"
                    color="primary"
                    variant="flat"
                    data-test="confirmation-dialog-btn-accept"
                    @click="onAccept"
                >
                    Confirm
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
